import { useEffect } from 'react';

export function useRepositioning({
  isOpen,
  isMobile,
  contentWrapperRef,
  applyPopoverPosition,
}: {
  isOpen: boolean;
  isMobile: boolean;
  contentWrapperRef: React.RefObject<HTMLDivElement>;
  applyPopoverPosition: () => void;
}) {
  useEffect(() => {
    if (!isOpen || isMobile) return;

    // Add smooth transition
    if (contentWrapperRef.current) {
      contentWrapperRef.current.style.transition = 'top 0.1s, left 0.1s';
    }

    // Initial positioning
    applyPopoverPosition();

    const handleScroll = () => {
      applyPopoverPosition();
    };

    // Add event listeners
    window.addEventListener('resize', applyPopoverPosition);
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener('resize', applyPopoverPosition);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isOpen, isMobile, applyPopoverPosition, contentWrapperRef]);
}
